import React, { useEffect, useState } from "react"
import API from "../../common/API"
import { parsedUser } from "../../common/GetCurrentUser"
import moment from "moment"
import { useTranslation } from "react-i18next"

const SummaryByStage = props => {
  const [filter, setFilter] = useState({})
  const [show, setShow] = useState(false)
  const [records, setRecords] = useState([])
  const user = parsedUser()
  const {t} = useTranslation();
  const bindDataRemote = async () => {
    let Query = "OrganizationId=" + user.OrganizationId
    if (filter.from) {
      Query += `&from=${moment(filter.from).format(
        "YYYY-MM-DD"
      )}&until=${moment(filter.until).format("YYYY-MM-DD")}`
    }
    if (filter.sector) {
      Query += `&sector=${filter.sector}`
    }
    if (filter.stageId) {
      Query += `&stageId=${filter.stageId}`
    }
    if (filter.categoryId) {
      Query += `&categoryId=${filter.categoryId} `
    }

    if (filter.placeVisitId) {
      Query += `&placeVisitId=${filter.placeVisitId} `
    }

    if (filter.assignedTo) {
      Query += `&assignedTo=${filter.assignedTo} `
    }
    var request = await API.getAction("place/SummaryByStage", Query)
    setRecords(request.data.response)
  }
  useEffect(() => {
    setFilter(props.filter)
  }, [props])
  useEffect(() => {
    bindDataRemote()
  }, [filter])
  return (
    <>   <button className="ms-2 btn btn-primary btn-sm" onClick={() => { setShow(!show) }}>
    {t('Stage')}
    </button>
    {show && records.map((item, index) => {
        return (
          <div className="badge text-dark me-2" key={index}>
            <i className={item.icon + " ms-2  me-2"}></i>
            <span className="d-none d-md-inline">{item.name}</span> {item.count}
          </div>
        )
      })}
    </>
  )
}

export default SummaryByStage
